import { render, staticRenderFns } from "./currencyCharge.vue?vue&type=template&id=bb9804b0"
import script from "./currencyCharge.vue?vue&type=script&lang=js"
export * from "./currencyCharge.vue?vue&type=script&lang=js"
import style0 from "./currencyCharge.vue?vue&type=style&index=0&id=bb9804b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports